import { api } from '@xtnd/web/shared/api';

export interface QueueStatistics {
    entityType: string;
    messagesAvailable: number;
    messagesInFlight: number;
    autoProcessingEnabled: boolean;
    lastProcessed?: string;
}

export interface AutoProcessingResponse {
    success: boolean;
    message: string;
}

class QboWebhookManagementApi {
    private readonly baseSource = '/webhook/qbo/v1/current';
    private readonly autoProcessingBase = `${this.baseSource}/auto-processing`;
    private readonly queueBase = `${this.baseSource}/queue`;

    /**
     * Enable auto-processing for a specific entity type
     */
    async enableAutoProcessing(entityType: string): Promise<AutoProcessingResponse> {
        return api.post<AutoProcessingResponse>(`${this.autoProcessingBase}/${entityType}/enable`);
    }

    /**
     * Disable auto-processing for a specific entity type
     */
    async disableAutoProcessing(entityType: string): Promise<AutoProcessingResponse> {
        return api.post<AutoProcessingResponse>(`${this.autoProcessingBase}/${entityType}/disable`);
    }

    /**
     * Get queue statistics for all entity types
     * Note: This would be a real API call in production
     */
    async getQueueStatistics(): Promise<QueueStatistics[]> {
        // Mock implementation - replace with real API call when backend is ready
        const entityTypes = ['invoice', 'customer', 'item', 'payment', 'bill'];

        return entityTypes.map(entityType => ({
            entityType,
            messagesAvailable: Math.floor(Math.random() * 10),
            messagesInFlight: Math.floor(Math.random() * 3),
            autoProcessingEnabled: entityType === 'invoice', // Only invoice is enabled from our setup
            lastProcessed: new Date(Date.now() - Math.random() * 86400000).toISOString(),
        }));
    }

    /**
     * Process a single message from queue (manual processing)
     */
    async processSingleMessage(entityType: string): Promise<{ success: boolean; processed: number }> {
        return api.post<{ success: boolean; processed: number }>(
            `${this.queueBase}/${entityType}/process-single`
        );
    }

    /**
     * Get queue statistics for a specific entity type
     */
    async getEntityQueueStats(entityType: string): Promise<QueueStatistics> {
        return api.get<QueueStatistics>(`${this.queueBase}/${entityType}/stats`);
    }
}

export const qboWebhookManagementApi = new QboWebhookManagementApi();

